import { useEffect, useRef, useState } from "react";

import Helpers from "../../commons/helpers";
import useWindowDimensions from "../../commons/dememsions";

import { IDataComment } from "../../commons/interfaces";
import { showAlert } from "../../providers/AlertProvider";
import { useCommentContext } from "../../providers/CommentProvider";
import { DeleteIcon, EditIcon, ThreeDot, WarningIcon } from "../../assets/icon/svg";

interface IProps {
    item: any;
    isDisableDelete?: boolean;
    isDisableUpdate?: boolean;
    isDisableReport?: boolean;
    deleteMessage: (messageId: string) => void;
    onReportComment?: (data: any) => void;
    handleSetDataReplyComment: (data: IDataComment) => void;
    handleSetIsUpdate: (value: boolean) => void;
    handleSetIdShowInputComment: (id: string) => void;
}

const Menu = ({
    item,
    isDisableDelete,
    isDisableUpdate,
    isDisableReport,
    deleteMessage,
    onReportComment,
    handleSetDataReplyComment,
    handleSetIsUpdate,
    handleSetIdShowInputComment,
}: IProps) => {
    const wrapperRef = useRef<any>(null);
    const { userLogin } = useCommentContext();

    const [openSlideByID, setOpenSlideByID] = useState<string>("");
    const [rect, setRect] = useState<any>();

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setOpenSlideByID("");
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    // show menu
    const handleOpenDropdown = (item: any) => {
        Helpers.isNullOrEmpty(openSlideByID) ? setOpenSlideByID(`${item.id}`) : setOpenSlideByID("");
    };

    // action
    const handleReport = (item: any) => {
        showAlert("Report thành công", "success");
        setOpenSlideByID("");
        Helpers.isFunction(onReportComment) && onReportComment(item);
    };

    const handleEdit = (item: any) => {
        setOpenSlideByID("");
        handleSetDataReplyComment(item);
        handleSetIdShowInputComment(`${item.id}`);
        handleSetIsUpdate(true);
    };

    const handleDelete = (item: any) => {
        Helpers.isFunction(deleteMessage) && deleteMessage(`${item.id}`);
        setOpenSlideByID("");
    };

    const myFunction = () => {
        const element = document.getElementById(`myDropdown${item.id}`)!;
        if (element === null) return;
        const rect = element.getBoundingClientRect();
        setRect(rect);
    };

    useEffect(() => {
        myFunction();
    }, [item, openSlideByID]);

    const { width } = useWindowDimensions();

    return (
        <div className="cr-dropdown" ref={wrapperRef}>
            {
                item.userComment?.userId === userLogin?.userId &&
                (!isDisableDelete || !isDisableReport || !isDisableUpdate) &&
                <button className="cr-dropdown-button" onClick={() => handleOpenDropdown(item)}>
                    <ThreeDot />
                </button>
            }
            <div
                id={`myDropdown${item.id}`}
                className="cr-dropdown-content"
                style={{
                    left: rect?.x >= width - 200 ? undefined : 0,
                    right: rect?.x >= width - 200 ? 0 : undefined,
                    display: openSlideByID === `${item.id}` ? "block" : "none",
                }}
            >
                {item.userComment?.userId !== userLogin?.userId && !isDisableReport && (
                    <button className="cr-dropdown-item" onClick={() => handleReport(item)}>
                        <WarningIcon width={16} height={16} /> <p>Báo cáo bình luận</p>
                    </button>
                )}

                {item.userComment?.userId === userLogin?.userId && !isDisableUpdate && (
                    <button className="cr-dropdown-item" onClick={() => handleEdit(item)}>
                        <EditIcon width={16} height={16} /> <p>Sửa</p>
                    </button>
                )}

                {item.userComment?.userId === userLogin?.userId && !isDisableDelete && (
                    <button className="cr-dropdown-item" onClick={() => handleDelete(item)}>
                        <DeleteIcon width={16} height={16} /> <p>Xóa</p>
                    </button>
                )}
            </div>
        </div>
    );
};

export default Menu;
